import styled from 'styled-components';

const Styles = styled.div`
  margin: 120px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 88%;
  .user-profile-header-left {
    width: 35%;
  }
  .user-orders-right {
    width: 65%;
  }
  .driver-actions-panel {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 12px;
  }
  .partner-mode-panel {
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 12px;
    padding: 16px;
    background: rgba(39, 41, 61, 0.55);
  }
  .partner-mode-copy {
    font-size: 0.92rem;
    color: rgba(255, 255, 255, 0.72);
    margin-bottom: 12px;
  }
  .partner-toggle-row {
    display: flex;
    gap: 10px;
    margin-bottom: 12px;
  }
  .partner-toggle-button {
    margin-right: 0;
  }
  .partner-commission-row {
    margin-bottom: 12px;
  }
  .partner-commission-row label {
    display: block;
    font-size: 0.85rem;
    margin-bottom: 6px;
  }
  .partner-save-button {
    margin-bottom: 12px;
  }
  .partner-status-copy {
    font-size: 0.9rem;
    margin-bottom: 8px;
  }
  .partner-status-copy.error {
    color: #ff6b6b;
  }
  .partner-status-copy.success {
    color: #2ecc71;
  }
  .partner-details-grid {
    display: grid;
    gap: 6px;
  }
  .driver-compliance-panel {
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 12px;
    padding: 16px;
    background: rgba(39, 41, 61, 0.55);
  }
  .driver-compliance-panel-error {
    color: #ffb3b3;
  }
  .driver-compliance-header-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 12px;
  }
  .driver-compliance-copy {
    font-size: 0.92rem;
    color: rgba(255, 255, 255, 0.72);
    margin-bottom: 12px;
  }
  .driver-compliance-label {
    display: block;
    font-size: 0.85rem;
    margin-bottom: 6px;
  }
  .driver-compliance-badge {
    border-radius: 999px;
    padding: 6px 12px;
    font-size: 0.8rem;
    font-weight: 600;
    text-transform: uppercase;
  }
  .driver-compliance-badge.eligible {
    background: rgba(46, 204, 113, 0.18);
    color: #8ce6b1;
  }
  .driver-compliance-badge.restricted {
    background: rgba(231, 76, 60, 0.2);
    color: #ffb3aa;
  }
  .driver-compliance-metadata {
    display: grid;
    gap: 8px;
    margin-bottom: 12px;
  }
  .driver-compliance-alert {
    border-radius: 10px;
    padding: 10px 12px;
    margin-bottom: 12px;
    font-size: 0.92rem;
  }
  .driver-compliance-alert-danger {
    background: rgba(231, 76, 60, 0.16);
    color: #ffb3aa;
  }
  .driver-compliance-alert-warning {
    background: rgba(243, 156, 18, 0.16);
    color: #ffd189;
  }
  .driver-compliance-table {
    margin-bottom: 16px;
  }
  .driver-compliance-editor {
    margin-bottom: 16px;
  }
  .driver-compliance-editor-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 12px;
    margin-bottom: 16px;
  }
  .driver-compliance-assets-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
  }
  .driver-compliance-asset-row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
    gap: 12px;
    margin-bottom: 12px;
    padding: 12px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 10px;
  }
  .driver-compliance-asset-remove {
    display: flex;
    align-items: flex-end;
  }
  .driver-compliance-actions-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
  }
  .driver-compliance-save-message.success {
    color: #8ce6b1;
  }
`;

export default Styles;
